// extracted by mini-css-extract-plugin
export default {"header__link":"HeaderAnchorLink_header__link__XUIYD"};